module.exports = __webpack_public_path__ + "static/media/ourTeamThird.a8bcae78.jpg";